import { useMemo } from 'react';
import { PageFeedComment } from 'model/indexTS';
import { TranslateInterface } from 'utils/translation';
import { BadgeColors } from 'ui-library/badge';
import { FeedCommentView } from './FeedCommentView';
import { FeedCommentFooter } from './FeedCommentFooter';

export interface FeedCommentProps extends TranslateInterface {
  feedComment: PageFeedComment;
  isPreview?: boolean;
}

export const FeedComment = ({ feedComment, t, isPreview = false }: FeedCommentProps): JSX.Element => {
  const badgeColor = useMemo(() => {
    if (!feedComment.hasTipped) {
      return undefined;
    }

    if (feedComment.tippedAmount >= 100) {
      return BadgeColors.Dangerous;
    }

    if (feedComment.tippedAmount >= 50) {
      return BadgeColors.Success;
    }

    if (feedComment.tippedAmount >= 10) {
      return BadgeColors.Warning;
    }

    return BadgeColors.Epic;
  }, [feedComment.hasTipped, feedComment.tippedAmount]);

  return (
    <FeedCommentView isPreview={isPreview} t={t} color={badgeColor} feedComment={feedComment}>
      <FeedCommentFooter isPreview={isPreview} color={badgeColor} feedComment={feedComment} t={t} />
    </FeedCommentView>
  );
};
